module.exports = __webpack_public_path__ + "assets/img/37_1615_big.4ac926b8.jpg";